// extracted by mini-css-extract-plugin
export default {"pageHeader":"Page_pageHeader__TAwk0","pageContent":"Page_pageContent__AwKek"};